const encoder = new TextEncoder();

function compareJsonKeys(left: string, right: string): number {
  return left < right ? -1 : left > right ? 1 : 0;
}

function canonicalJsonText(
  value: unknown,
  inArray = false,
): string | undefined {
  if (value === null) return "null";
  if (typeof value === "string" || typeof value === "boolean") {
    return JSON.stringify(value);
  }
  if (typeof value === "number") {
    if (!Number.isFinite(value)) {
      throw new Error("Canonical Figma JSON cannot contain non-finite numbers");
    }
    return JSON.stringify(value);
  }
  if (
    value === undefined ||
    typeof value === "function" ||
    typeof value === "symbol"
  ) {
    return inArray ? "null" : undefined;
  }
  if (typeof value === "bigint") {
    throw new Error("Canonical Figma JSON cannot contain bigint values");
  }
  if (Array.isArray(value)) {
    return `[${value
      .map((entry) => canonicalJsonText(entry, true) ?? "null")
      .join(",")}]`;
  }
  const record = value as Record<string, unknown>;
  const entries = Object.keys(record)
    .sort(compareJsonKeys)
    .flatMap((key) => {
      const encoded = canonicalJsonText(record[key]);
      return encoded === undefined ? [] : [`${JSON.stringify(key)}:${encoded}`];
    });
  return `{${entries.join(",")}}`;
}

export function canonicalFigmaSourceJson(value: unknown): string {
  const encoded = canonicalJsonText(value);
  if (encoded === undefined) {
    throw new Error("Canonical Figma source must be a JSON value");
  }
  return encoded;
}

export async function sha256Utf8Hex(text: string): Promise<string> {
  return sha256BytesHex(encoder.encode(text));
}

export async function sha256BytesHex(bytes: Uint8Array): Promise<string> {
  if (!globalThis.crypto?.subtle) {
    throw new Error("SHA-256 verifier is unavailable");
  }
  const digest = await globalThis.crypto.subtle.digest(
    "SHA-256",
    new Uint8Array(bytes),
  );
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}

export async function canonicalFigmaSourceSha256(
  value: unknown,
): Promise<string> {
  return sha256Utf8Hex(canonicalFigmaSourceJson(value));
}
